import { render, staticRenderFns } from "./ProjectCommerciaInformation.vue?vue&type=template&id=023950b8&scoped=true&"
import script from "./ProjectCommerciaInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectCommerciaInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCommerciaInformation.vue?vue&type=style&index=0&id=023950b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023950b8",
  null
  
)

export default component.exports